import { Button } from '@mui/material';
import React from 'react';

interface ActionButtonsProps {
  image: string;
  title: string;
  action?: () => void;
  activeData?: string[];
  activeButton?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  image,
  title,
  action,
  activeData,
  activeButton,
}) => {
  return (
    <div className="action-card">
      <Button
        className={
          (activeData && activeData?.length > 0) || activeButton
            ? 'action-card_btn filter_buttons-active'
            : 'action-card_btn'
        }
        onClick={action}
      >
        <img src={image} alt="Map img" />
        <h5>{title}</h5>
        {activeData && activeData?.length > 0 && (
          <div className="filter_buttons-active-filtercount">
            <p>{activeData?.length}</p>
          </div>
        )}
      </Button>
    </div>
  );
};

const MemoizedComponent = React.memo(ActionButtons);
export default MemoizedComponent;
